import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { firestoreConnect, isLoaded } from "react-redux-firebase";
import { compose } from "redux";
import { Loader, Pagination, Button, Icon, Popup } from "semantic-ui-react";
import EventCard from "../components/layout/EventCard";
import EventList from "../components/layout/EventList";
import EventsFilter from "../components/layout/EventsFilter";
import { getFilteredEvents } from "../utils/utils";
const Events = (props) => {
  const [totalPages, setTotalPages] = useState(1);
  const [activePage, setActivePage] = useState(1);
  const [perPage, setPerPage] = useState(12);
  const [data, setData] = useState([]);
  const [events, setEvents] = useState([]);
  const [todayToggle, setTodayToggle] = useState(false);
  const [defaultView, setDefault] = useState(true);
  const [list, setList] = useState(false);
  const [search, setSearch] = useState(null);
  useEffect(() => {
    setEvents(props.events);
  }, [props.events]);

  useEffect(() => {
    let todaysData = [...events];
    if (todayToggle) {
      todaysData = todaysData.filter(
        (e) => e.eventEndDate <= new Date() || new Date() <= e.eventStartDate
      );
      todaysData = todaysData.sort(
        (date1, date2) => date2.eventStartDate - date1.eventStartDate
      );
    }
    if (search && search.length > 0) {
      todaysData = todaysData.filter((event) => {
        return (
          event.eventName.toLowerCase().match(search) ||
          (event.eventLocation &&
            event.eventLocation.toLowerCase().match(search)) ||
          event.eventSport.toLowerCase().match(search)
        );
      });
    }
    const paginated =
      todaysData &&
      todaysData.slice((activePage - 1) * perPage, activePage * perPage);
    setTotalPages(Math.ceil(todaysData.length / perPage));
    setData(paginated);
  }, [activePage, events, todayToggle, perPage, search]);
  const handleTodayEvent = () => {
    setTodayToggle(true);
    setActivePage(1);
  };
  const handleRegularEvent = () => {
    setTodayToggle(false);
    setActivePage(1);
  };
  const handleSearch = (data) => {
    setSearch(data);
    setActivePage(1);
  };
  if (!props.auth.isLoaded) {
    return (
      <>
        <div className="SpinnerBackground">
          <div className="SpinnerContainer">
            <Loader size="large" active inline="centered" />
          </div>
        </div>
      </>
    );
  } else if (props.auth.isLoaded && isLoaded(props.events)) {
    const pageChange = (not, data) => {
      setActivePage(data.activePage);
    };
    return (
      <>
        <div className="AthleteDetailsBackground cu-profile">
          <div className="AthleteDetailsBannerBar"></div>
          <EventsFilter
            onChange={() => setActivePage(1)}
            searchQuery={handleSearch}
          />
          <div className="AthleteDetailsButtonContainer event-header">
            <div className="first-div">
              {!todayToggle && (
                <Button
                  icon
                  labelPosition="left"
                  color="green"
                  onClick={handleTodayEvent}
                >
                  <Icon name="calendar check outline" />
                  <span className="todaysEvent">All Events</span>
                </Button>
              )}
              {todayToggle && (
                <Button
                  icon
                  labelPosition="youtube"
                  color="youtube"
                  onClick={handleRegularEvent}
                >
                  <Icon name="calendar alternate outline" />
                  <span className="todaysEvent">Regular View</span>
                </Button>
              )}
            </div>
            <div className="second-div">
              <div className="list-btn-box">
                <div className="gridBoxDiv">
                  <Popup
                    content="Standard View"
                    trigger={
                      <Button
                        className={defaultView ? "primary" : ""}
                        onClick={() => {
                          setList(false);
                          setDefault(true);
                          setPerPage(12);
                        }}
                      >
                        <Icon name="grid layout" />
                      </Button>
                    }
                  />
                  <Popup
                    content="List View"
                    trigger={
                      <Button
                        className={list ? "primary" : ""}
                        onClick={() => {
                          setList(true);
                          setDefault(false);
                          setPerPage(20);
                        }}
                      >
                        <Icon name="list ul" />
                      </Button>
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="AthleteEventsInfoContainer common-event">
            {data && data.length < 1 && (
              <p className="not-found cu-center">There's No Data Right Now</p>
            )}
            {defaultView ? (
              <>
                <div
                  className={`AthleteEventsGroupContainer ${
                    data &&
                    (data.length === 1
                      ? "onlyone"
                      : data.length === 2
                      ? "onlytwo"
                      : "")
                  }`}
                >
                  {data &&
                    data.map((event) => (
                      <EventCard
                        key={event.eventId}
                        eyShow={true}
                        id={event.eventId}
                        name={event.eventName}
                        startDate={
                          typeof event.eventStartDate !== "string"
                            ? event.eventStartDate.toDate().toDateString()
                            : event.eventStartDate
                        }
                        endDate={
                          typeof event.eventEndDate !== "string"
                            ? event.eventEndDate.toDate().toDateString()
                            : event.eventEndtDate
                        }
                        url={event.eventUrl}
                        visitors={event.eventAttenders}
                        advocate={event.eventAdvocate}
                        location={event.eventLocation}
                        attendant={event.attenders}
                        status={event.eventStatus}
                        sport={event.eventSport}
                        superAdmin={props.superAdmin}
                        creator={event.eventCreator}
                        view={defaultView ? "defaultView" : "list"}
                      />
                    ))}
                </div>
              </>
            ) : (
              <>
                <div className="AthleteEventsGroupContainer EventListView">
                  {data &&
                    data.map((event) => (
                      <EventList
                        key={event.eventId}
                        eyShow={true}
                        id={event.eventId}
                        name={event.eventName}
                        startDate={
                          typeof event.eventStartDate !== "string"
                            ? event.eventStartDate.toDate().toDateString()
                            : event.eventStartDate
                        }
                        endDate={
                          typeof event.eventEndDate !== "string"
                            ? event.eventEndDate.toDate().toDateString()
                            : event.eventEndtDate
                        }
                        url={event.eventUrl}
                        visitors={event.eventAttenders}
                        advocate={event.eventAdvocate}
                        location={event.eventLocation}
                        attendant={event.attenders}
                        status={event.eventStatus}
                        sport={event.eventSport}
                        superAdmin={props.superAdmin}
                        creator={event.eventCreator}
                        view={defaultView ? "defaultView" : "list"}
                      />
                    ))}
                </div>
              </>
            )}
          </div>

          {/* pagination and pages show */}
          <div className="AthleteSearchDetail AthletePagination justify-center">
            <Pagination
              onPageChange={pageChange}
              activePage={activePage}
              firstItem={null}
              lastItem={null}
              prevItem={{ content: <Icon name="angle left" />, icon: true }}
              nextItem={{
                content: <Icon name="angle right" />,
                icon: true,
              }}
              pointing
              secondary
              totalPages={totalPages}
            />
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        <div className="SpinnerBackground">
          <div className="SpinnerContainer">
            <Loader size="large" active inline="centered" />
          </div>
        </div>
      </>
    );
  }
};

const mapStateToProps = (state) => {
  let events = [];
  if (
    state.firestore.data.events &&
    state.firestore.data.athletes &&
    state.firestore.data.advocates
  ) {
    const keys = Object.keys(state.firestore.data.events);
    const rawEvents = keys.map((key) => {
      if (
        state.firestore.data.events[key] &&
        state.firestore.data.events[key].eventStatus
      ) {
        let event = state.firestore.data.events[key];
        if (event) {
          let attenders = event.eventAttenders;
          attenders = attenders.map((visitor) => {
            const person = {};
            if (visitor in state.firestore.data.athletes) {
              person.name =
                state.firestore.data.athletes[visitor].firstName +
                " " +
                state.firestore.data.athletes[visitor].lastName;
              person.image = state.firestore.data.athletes[visitor].thumbnail;
              person.id = visitor;
              person.customUrl =
                state.firestore.data.athletes[visitor].customUrl;
              person.extraData = state.firestore.data.athletes[visitor];
            } else if (visitor in state.firestore.data.advocates) {
              person.name = state.firestore.data.advocates[visitor].name;
              person.image =
                state.firestore.data.advocates[visitor].thumbnailUrl;
              person.id = visitor;
              person.customUrl =
                state.firestore.data.advocates[visitor].customUrl;
            }
            return person;
          });
          return { ...event, attenders };
        }
      }
    });
    events = rawEvents.filter((event) => event);
    events = events.sort(
      (date1, date2) => date1.eventStartDate - date2.eventStartDate
    );

    let date = new Date();
    date.setDate(date.getDate() - 1);
    const filteredEvents = events.filter((e) =>
      typeof e.eventEndDate !== "string"
        ? e.eventEndDate.toDate() >= date
        : false
    );
    const filteredEvents3 = events.filter(
      (e) => typeof e.eventEndDate === "string"
    );
    events = [...filteredEvents, ...filteredEvents3];
  }
  return {
    events: events ? events.filter((event) => event) : [],
    auth: state.firebase.auth,
    superAdmin: state.auth.superAdmin,
    sport: state.athlete.sport,
    date: state.athlete.date,
    creator: state.athlete.creator,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => [
    getFilteredEvents(props.sport, props.creator, props.date),
    {
      collection: "adminAthletes",
      storeAs: "athletes",
    },
    {
      collection: "advocates",
    },
  ])
)(Events);
